import { gql } from '@apollo/client';

export type DeviceEvent = {
  id: string;
  friendlyId: string;
  type: string;
  isIncludedToReport: boolean;
  start: string;
  stop: string;
  reason: string;
  comments: string;
  stripImgs: string[];
  selected: boolean;
  isValid: boolean;
  carriedBySentReport: boolean;
  hrInfo: any;
  realtimeData: { start: string; stop: string };
  reportData: { report: { id: string; formatVersion: string } };
};

const deviceEventFragment = gql`
  {
    id
    friendlyId
    type
    isIncludedToReport
    start
    stop
    reason
    comments
    stripImgs
    selected
    isValid
    carriedBySentReport
    hrInfo
    realtimeData {
      start
      stop
    }
    reportData {
      report {
        id
        formatVersion
      }
    }
  }
`;

const NOTIFICATION_EVENT_QUERY = gql`
  query deviceEventsV2($filter: DeviceEventsInput) {
    deviceEventsV2(filter: $filter) {
      notificationEvents {
        events {
          ...${deviceEventFragment}
        }
      }
    }
  }
`;
const PATIENT_TRIGGERED_EVENT_QUERY = gql`
  query deviceEventsV2($filter: DeviceEventsInput) {
    deviceEventsV2(filter: $filter) {
      patientTriggeredEvents {
        events {
          ...${deviceEventFragment}
        }
      }
    }
  }
`;

const OTHER_EVENT_QUERY = gql`
  query deviceEventsV2($filter: DeviceEventsInput) {
    deviceEventsV2(filter: $filter) {
      otherEvents {
        events {
          ...${deviceEventFragment}
        }
      }
    }
  }
`;
/**
 * Selects the GraphQL document used to page device events for a given device-event tab. Switches on the numeric tab key, mapping 0 to the notification-event query, 1 to the patient-triggered-event query and 2 to the other-event query, with the notification query as the default fallback.
 *
 * @param key - Numeric device-event tab key to resolve a query document for.
 * @returns The GraphQL query document for the requested device-event tab.
 */
const DEVICE_EVENT_QUERY = (key: number) => {
  switch (key) {
    case 0:
      return NOTIFICATION_EVENT_QUERY;
    case 1:
      return PATIENT_TRIGGERED_EVENT_QUERY;
    case 2:
      return OTHER_EVENT_QUERY;
    default:
      return NOTIFICATION_EVENT_QUERY;
  }
};

export default DEVICE_EVENT_QUERY;
